import { useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import classNames from "classnames";
import { useHistory } from "react-router-dom";

import styles from "./GroupsList.module.css";
import PropTypes from "prop-types";
import GroupItem from "../GroupItem";

/**
 *
 * Scrollable list of groups with a header.
 */

export function GroupsList({ groups, empty }) {
  const history = useHistory();
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref); // Now we pass the reference to the useDraggable hook:

  const handleDetails = (data) => {
    // setDetailsModalOpen(true);
    // setSelectedPlugin(data);
  };

  return (
    <div className={styles.container}>
      <div className={classNames(styles.header, empty && styles.empty)}>
        {/* <div
        className={classNames(styles.header, empty ? styles.empty : undefined)} */}

        <div className={styles.item}>IBO #</div>
        <div className={styles.item}>Organization</div>
        <div className={styles.item}>Group Name</div>
        <div className={styles.item}>Group Type</div>
        {/* <div className={styles.item}>Group ID #</div> */}
      </div>
      {/* <div
        className={classNames(
          styles.dragger,
          empty ? styles.emptyHeight : undefined
        )} */}
      <div
        className={classNames(styles.dragger, empty && styles.emptyHeight)}
        {...events}
        ref={ref}
      >
        {groups.map((item, index) => (
          <div
            className={
              index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
            }
            key={index}
          >
            <GroupItem
              groupInfo={item}
              empty={empty}
              // onClick={() => handleDetails(item)}
              onClick={() => history.push("/dreamstream/group")}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

GroupsList.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object),
  empty: PropTypes.bool,
};
